import script from "./Table.vue?vue&type=script&setup=true&lang=ts"
export * from "./Table.vue?vue&type=script&setup=true&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=7a2afc6d&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2afc6d"]])

export default __exports__